module.exports = __webpack_public_path__ + "static/media/bubble8.7554765c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/bubble8.svg
// module id = 2498
// module chunks = 7